<template>
	<form @submit.prevent="createUser()" class="mb-5">
		<div class="row">
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="firstName"
					label="First Name"
					type="text"
					v-model="user.firstName"
					class="form-control form-control-lg dashInput"
					:required="true"
					rules="required|min:3|max:40"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="lastName"
					label="Last Name"
					type="text"
					:required="true"
					v-model="user.lastName"
					class="form-control form-control-lg dashInput"
					rules="required|min:3|max:40"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="phone"
					label="Mobile Number"
					type="number"
					:min="0"
					:required="true"
					v-model="user.phone"
					class="form-control form-control-lg dashInput"
					rules="required|min:10|max:10"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="email"
					label="Email"
					type="email"
					v-model="user.email"
					:required="true"
					class="form-control form-control-lg dashInput"
					rules="required|email"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="password"
					label="Password"
					type="password"
					:required="true"
					v-model="user.password"
					class="form-control form-control-lg dashInput"
					rules="required|min:4"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="password"
					label="Confirm Password"
					type="password"
					:required="true"
					v-model="user.confirmPassword"
					class="form-control form-control-lg dashInput"
					rules="required|min:4"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
				<span v-if="password.error" class="text-danger small">
					{{ password.error }}
				</span>
			</div>

			<div class="form-group col-sm-6">
				<BaseMultiSelect
					@update:value="setRole"
					:options="multiSelectState.rolesSelect"
					rules="required"
					mode="single"
					name="Role"
					:required="true"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>

			<div v-if="user.role !== roles.env_admin" class="form-group col-sm-6">
				<BaseMultiSelect
					@update:value="setUser"
					:options="multiSelectState.userSelect"
					rules="required"
					mode="single"
					name="Assign To"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="area"
					label="Area"
					type="text"
					v-model="user.area"
					:required="true"
					class="form-control form-control-lg dashInput"
					rules="required|min:4|max:50"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>

			<div class="form-group col-sm-6">
				<BaseMultiSelect
					@update:value="setTargetType"
					:options="multiSelectState.targetSelect"
					rules="required"
					mode="single"
					name="Target Complete In"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="enquiryTarget"
					label="Enquiry Target"
					type="number"
					:min="0"
					v-model="user.enquiryTarget"
					class="form-control form-control-lg dashInput"
					rules="required|min:1"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="bookingTarget"
					label="Booking Amount Target"
					type="number"
					:min="0"
					v-model="user.bookingTarget"
					class="form-control form-control-lg dashInput"
					rules="required|min:2"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="Google App Password"
					label="Google App Password"
					type="text"
					v-model="user.googleAppPass"
					class="form-control form-control-lg dashInput"
					rules="required"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="col-sm-12">
				<div class="form-check form-switch">
					<input
						class="form-check-input"
						v-model="image.enabled"
						type="checkbox"
						id="imageCheck"
					/>
					<label class="form-check-label text-dark" for="imageCheck"
						>Upload user image</label
					>
				</div>
			</div>
			<div v-if="image.enabled" class="col-sm-12">
				<BaseImageUpload urlParam="users" @images-data="setImage" />
			</div>

			<div class="form-group col-sm-6 mt-2 mb-4">
				<BaseButton
					class="btn btn-primary form-control"
					type="submit"
					label="Create"
					:disabled="formState.disable"
					:loading="formState.isLoading"
				/>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, inject, watch, onMounted } from "vue";
	import { useRouter } from "vue-router";
	import API from "@/config/api";
	import BaseInput from "./BaseInput.vue";
	import BaseButton from "./BaseButton.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseImageUpload from "./BaseImageUpload.vue";
	import toast from "@/config/toast";
	import Helper from "@/helpers/dataHelper";

	export default {
		name: "UserCreate",
		components: {
			BaseInput,
			BaseButton,
			BaseMultiSelect,
			BaseImageUpload,
		},
		setup: () => {
			const store = inject("store");
			const masterStore = inject("masterStore");
			const router = useRouter();

			const roles = reactive({
				env_admin: process.env.VUE_APP_USER_ADMIN,
			});

			const user = reactive({
				firstName: null,
				lastName: null,
				phone: null,
				email: null,
				password: null,
				confirmPassword: null,
				role: [],
				assignTo: null,
				area: null,
				targetType: null,
				enquiryTarget: null,
				bookingTarget: null,
				image: null,
				googleAppPass: null,
			});

			const formState = reactive({
				isLoading: false,
				disable: true,
			});

			const validation = reactive({
				invalid: [],
				valid: [],
				nullable: ["enquiryTarget", "bookingTarget", "enquiryType"],
			});

			const password = reactive({
				status: false,
				error: null,
				type: "password",
				show: false,
				icon: "bi-eye",
			});

			const multiSelectState = reactive({
				rolesSelect: Helper.roles.map((role) => ({
					value: role,
					label: role.replace(/_/g, " "),
				})),
				userSelect: [],
				targetSelect: ["Days", "Month"],
			});

			const image = reactive({
				enabled: false,
			});

			if (!store.state.auth.isAuth) router.push({ path: "/login" });

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			const createUser = async () => {
				changeFormLoadingState();
				formState.disable = true;

				if (validation.invalid.length) {
					toast.error("Incomplete form", true);
					changeFormLoadingState();
					return;
				}
				let message;
				try {
					let response = await API.privateRequest.post("/auth/register", user);
					console.log("response::", response);
					if (response) {
						toast.success(
							{ message: "User Created!", position: "topRight" },
							true,
						);
					} else {
						toast.error("Something went wrong");
					}

					changeFormLoadingState();
					// await store.methods.transformAndSetUser(response.data.data[0]);
					// await store.methods.saveState();
					// router.push({ path: '/dash' })
					masterStore.methods.changeComponent("table");
				} catch (err) {
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
					changeFormLoadingState();
					formState.disable = false;
				}
			};

			watch(
				() => user,
				(newVal, preVal) => {
					if (user.password !== user.confirmPassword && !password.error) {
						password.error = "New password and confirm password are not same.";
						formState.disable = true;
					}
					if (user.password === user.confirmPassword && password.error) {
						formState.disable = false;
						password.error = null;
					}
				},
				{ deep: true },
			);

			const getUsers = async () => {
				try {
					let query = "";

					if (!user.role.length) return;
					else if (user.area)
						query = `selectedRole=${user.role[0]}&area=${user.area}`;
					else query = `selectedRole=${user.role[0]}&`;

					const response = await API.privateRequest.get(`users?${query}`);

					multiSelectState.userSelect = response.data.data.map((user) => ({
						label: `${user.firstName} ${user.lastName}`,
						value: user._id,
					}));
				} catch (err) {
					console.log("error getting users");
					console.log(err);
				}
			};

			const setUser = (payload) => {
				user.assignTo = payload;
			};

			const setRole = (payload) => {
				user.role[0] = payload;
				getUsers();
			};

			const setTargetType = (payload) => {
				user.targetType = payload;
			};

			const setImage = (images) => {
				console.log(" uploaded image and now in setImage", images);
				if (!images.length) return;
				data.image = images[0];
			};

			//? checking conditions to enable or disable form login button
			const checkForm = () => {
				let valLength = validation.valid.length;
				let inValLength = validation.invalid.length;
				let formLength = Object.keys(user).length;
				let formInputs = Object.keys(user); //!formInputs should be in formState
				let nullables = Object.values(validation.nullable);
				let notNullable = [];

				for (let nullable of nullables) {
					for (let [index, formInput] of formInputs.entries()) {
						if (nullable === formInput) {
							delete formInputs[index];
							break;
						} else if (!formInput) break;
						else notNullable.push(formInput);
					}
				}
				notNullable = [...new Set(notNullable)];

				let notNullableInvalids = notNullable.flatMap((item) => {
					let catchInValid = validation.invalid.includes(item);
					return catchInValid;
				});

				//? removing falsy values from array
				let check = notNullableInvalids.filter(Boolean);

				if (
					!inValLength &&
					!check.length &&
					valLength + notNullable.length >= formLength
				) {
					formState.disable = false;
				} else formState.disable = true;
			};

			//? adding and removing form fields from valid and invalid state
			const setFormVal = (data) => {
				if (validation.invalid.length) {
					const newInvalid = validation.invalid.filter(
						(error) => error.field !== data.field,
					);
					validation.invalid = newInvalid;
				}
				if (validation.valid.length) {
					const newValid = validation.valid.filter(
						(item) => item.field !== data.field,
					);
					validation.valid = newValid;
				}
				return;
			};

			// event handler for valError event
			const valError = (data) => {
				// toast.error(`${data.field} is required`, true);
				setFormVal(data);
				validation.invalid = [...validation.invalid, data];
				checkForm();
			};

			const valSuccess = (data) => {
				setFormVal(data);
				validation.valid = [...validation.valid, data];
				checkForm();
			};

			return {
				user,
				store,
				roles,
				multiSelectState,
				image,
				password,
				createUser,
				setUser,
				setRole,
				setTargetType,
				setImage,
				valError,
				valSuccess,
				validation,
				formState,
			};
		},
	};
</script>
